const e = [
  { name: "Patient Gender", value: void 0 },
  { name: "Male", value: "Male" },
  { name: "Female", value: "Female" }
];
export {
  e as default
};
